import React, { Component } from 'react';
import { Control, Errors } from 'react-redux-form/immutable';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { v4 as uuid } from 'uuid';
import { FieldHelpIcon } from '../icon/FieldHelpIcon';
import { helpModalControl } from '../modals/HelpModalControl';

class LabeledTextUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.handleHelpClick = this.handleHelpClick.bind(this);
    this.id = `i${uuid()}`;
  }

  handleHelpClick(e) {
    e.preventDefault();
    const { toggleHelpModal, helpModalId } = this.props;
    if (helpModalId) {
      toggleHelpModal(helpModalId);
    }
  }

  render() {
    const {
      model, label, readOnly, formGroupClassName, helpModalId, name, // ariaLabelledby,
    } = this.props;
    return (
      <div className={classnames(['form-group', ...formGroupClassName])}>
        <label className={classnames({ 'sr-only': !label })} htmlFor={this.id}>
          <div className="haz-help-icon-inline">
            <span>{label || 'Value'}</span>
            {helpModalId && <span><FieldHelpIcon tooltipLabel={helpModalId} handleClick={this.handleHelpClick} /></span>}
          </div>
        </label>
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <Control.text
          model={model}
          id={this.id}
          aria-label={name}
          mapProps={{
            readOnly,
            className: ({ fieldValue }) => classnames({ 'form-control': true, 'is-invalid': !fieldValue.valid }),
          }}
        />
        <Errors
          model={model}
          component="div"
          wrapper={({ children }) => <div className="invalid-feedback">{children}</div>}
        />
      </div>
    );
  }
}

LabeledTextUnwrapped.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  readOnly: PropTypes.bool,
  formGroupClassName: PropTypes.arrayOf(PropTypes.string),
  toggleHelpModal: PropTypes.func.isRequired,
  helpModalId: PropTypes.string,
  name: PropTypes.string,
};

LabeledTextUnwrapped.defaultProps = {
  label: undefined,
  readOnly: false,
  formGroupClassName: [],
  helpModalId: undefined,
  name: undefined,
};

export const LabeledText = helpModalControl(LabeledTextUnwrapped);
